import { render, staticRenderFns } from "./IncRnaSingleGeneExpression.vue?vue&type=template&id=152d82bd&scoped=true"
import script from "./IncRnaSingleGeneExpression.vue?vue&type=script&lang=js"
export * from "./IncRnaSingleGeneExpression.vue?vue&type=script&lang=js"
import style0 from "./IncRnaSingleGeneExpression.vue?vue&type=style&index=0&id=152d82bd&prod&scoped=true&lang=css"
import style1 from "./IncRnaSingleGeneExpression.vue?vue&type=style&index=1&id=152d82bd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152d82bd",
  null
  
)

export default component.exports